var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4754 15.7647L20.7601 13.4801L18.4754 11.1954C16.8406 9.56053 14.1785 9.56053 12.5435 11.1954L10.2798 13.4801L12.5645 15.7647C14.1995 17.3996 16.8406 17.3996 18.4756 15.7647H18.4754ZM15.5201 13.4801V11.3838C16.6729 11.3838 17.6161 12.327 17.6161 13.4798C17.6161 14.6327 16.6729 15.5759 15.5201 15.5759C14.3672 15.5759 13.424 14.6327 13.424 13.4798L15.5201 13.4801Z",
    fill: "#001EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4673 26.9993L8.87521 21.5914C10.6987 23.0798 13.0044 23.9602 15.5197 23.9602C21.3046 23.9602 26 19.2649 26 13.4798C26 7.69436 21.3047 2.99951 15.5197 2.99951C9.73419 2.99951 5.03935 7.69457 5.03935 13.4798C5.03935 15.995 5.91969 18.3007 7.40791 20.1035L2 25.5322L3.4673 26.9993ZM7.13557 13.4798C7.13557 8.84762 10.8875 5.09558 15.5198 5.09558C20.1521 5.09558 23.9041 8.84746 23.9041 13.4798C23.9039 18.1121 20.152 21.8641 15.5198 21.8641C10.8874 21.8641 7.13557 18.1122 7.13557 13.4798Z",
    fill: "#001EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLight);
export default __webpack_public_path__ + "static/media/search-light.40c73f10611a6db476ee00cc1095dee8.svg";
export { ForwardRef as ReactComponent };